import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaGraduationCap } from "react-icons/fa";

function Education() {
  return (
    <Container fluid className="education-section">
      <Container>
        <h1 className="project-heading">
          My <strong className="purple">Education</strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Col md={8}>
            <div className="education-card">
              <div className="education-icon">
                <FaGraduationCap />
              </div>
              <div className="education-content">
                <h3 className="education-title">Dr. D.Y. Patil College of Engineering and Innovation</h3>
                <h4 className="education-degree">Bachelor of Engineering in Computer Engineering</h4>
                <p className="education-period">2023 - 2027 | Pune, India</p>
                <p className="education-desc">
                  Currently pursuing with focus on full-stack development, data structures, and algorithms.
                  Active participant in coding competitions and technical events.
                </p>
              </div>
            </div>

            <div className="education-card">
              <div className="education-icon">
                <FaGraduationCap />
              </div>
              <div className="education-content">
                <h3 className="education-title">ST. Paul Junior College</h3>
                <h4 className="education-degree">HSC (12th) - Science</h4>
                <p className="education-period">2021 - 2023 | Nagpur, Maharashtra</p>
                <p className="education-desc">
                  Completed higher secondary education with 72.84% in HSC.
                </p>
              </div>
            </div>

            <div className="education-card">
              <div className="education-icon">
                <FaGraduationCap />
              </div>
              <div className="education-content">
                <h3 className="education-title">Shri Chaitanya Olympaid School</h3>
                <h4 className="education-degree">SSC (10th)</h4>
                <p className="education-period">Completed | Tadepalligudem,Andhra Pradesh</p>
                <p className="education-desc">
                  Completed with 91% in SSC. Strong academic foundation with active involvement in extracurricular activities.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Education;